/**
 * Act 1 coordinator — sequences Scene 1 → 2 → 3, owns history,
 * emits context-clear markers at scene boundaries.
 * Spec: BLUEPRINT.md § Components.
 */
import type { ChatPanelApi } from "./ui/chatPanel";
import type { GameScene } from "../../scene/src/scenes/GameScene";
import type { CubicleApi } from "../../cubicle/src/cubicle";
import type { HistoryTurn } from "./lib/chat";
import { startScene1 } from "./scene1/harness";
import { startScene2 } from "./scene2/harness";
import { startScene3 } from "./scene3/harness";

export function startAct1(deps: {
  chat: ChatPanelApi;
  scene: GameScene;
  cubicle: CubicleApi;
}): { run: () => Promise<void> } {
  const history: HistoryTurn[] = [];

  async function interSceneTransition(stage: "scene2" | "scene3"): Promise<void> {
    history.length = 0;
    deps.chat.appendSystem({ header: "** CONTEXT CLEAR **" });
    deps.cubicle.setChromeStrip(stage);
  }

  return {
    async run(): Promise<void> {
      const s1 = startScene1({ ...deps, history });
      await s1.run();

      await interSceneTransition("scene2");

      const s2 = startScene2({ ...deps, history });
      await s2.run();

      await interSceneTransition("scene3");

      const s3 = startScene3({ ...deps, history });
      await s3.run();
    },
  };
}
